export const Constants = {
    success:'#d2f0ff',
    error:'#ffdae7',
    warning:'#fffce8',
    white:'#ffffff',
    successText:'#00378b',
    errorText:'#9b0b16',
    warningText:'#856404',
}
export const Types = {
    indicator:'indicator',
    intervention:'intervention',
    warning:'warning'
}

export const Responses = {
    accept:'accept',
    decline:'decline',
    ignore:'ignore'
}

export const ROLES = {
    ADMIN: 1,
    AGENT: 3,
    ACCOUNTANT: 2
}

export const COMMISION_TYPES = {
    CRUISE: 'cruise',
    ALL: 'all',
}

export const PAYMENT_TYPES = [
    {
        id: 'cash',
        title: 'Cash'
    },
    {
        id: 'credit_card',
        title: 'Credit Card'
    },
    {
        id: 'paypal',
        title: 'Paypal'
    },
    {
        id: 'bank_transfer',
        title: 'Bank Transfer'
    },
    {
        id: 'invoice',
        title: 'Invoice'
    },
];

export const PAYMENT_METHODS = [
    {
        id: 'deposit',
        title: 'Deposit Collected'
    },
    {
        id: 'full',
        title: 'Full Payment Collected (Hera to invoice)'
    },
    {
        id: 'none',
        title: 'No Payment Collected (Full payment on board)'
    },
];
